export default __webpack_public_path__ + "static/warehouse-light-68827c5898dfa63abea00a12504ad587.png";